import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import "./AlarmVideoOverlay.html";
import "./AlarmVideoOverlay.scss";

import { AlarmVideoOverlayComponentController } from "./AlarmVideoOverlayComponentController";

export class AlarmVideoOverlayComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            url: "@",
            w: "@",
            h: "@",
            overlayid: "@",
        };
        this.controller = AlarmVideoOverlayComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/AlarmVideo/AlarmVideoOverlay.html";
        this.transclude = false;
    }
}
